module.exports = __webpack_public_path__ + "img/DIRE-mockup-portatile.3fad98d1.png";